import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-mobile-build-status',
  templateUrl: './mobile-build-status.component.html',
})
export class MobileBuildStatusComponent {
  @Input() fields: any[] = [];
  @Input() entity: any;
}
